import { ButtonConfig } from 'src/app/models/button.component.model';
import { SiteUserModel } from './user-management.model';
export class SiteModel {
  constructor(
    public siteId?: string,
    public Select?: boolean,
    public siteName?: string,
    public attachments?: any,
    public addressBlockNo?: string,
    public addressLocality?: string,
    public pinCode?: string,
    // public initialContactDate?: number,
    public commissionStartDate?: number,
    public goLiveDate?: number,
    public city?: string,
    public industryType?: string,
    public nextFollowUpDate?: number,
    public executionState?: string,
    public leadType?: string,
    public leadGeneratedBy?: string,
    public conversionFlag?: string,
    public featureOpted?: string,
    public industrySegment?: string,
    public contactPersonName?: string,
    public contactNo?: string,
    public altContactNo?: string,
    public contactEmail?: string,
    public timezone?: string,
    public energyCalcMethod?: string,
    public layoutNavigateFeature?: boolean,
    public sensorHealth?: number,
    public ControlConfig?: ButtonConfig[],
    public siteUsers?: SiteUserModel[],
    public configuredKpiUtilities?: string[],
    public availableKPIUtilities?: string[]
  ) {}

  compare(site: SiteModel, attribute: string): number {
    let value = 0;
    switch (attribute) {
      case 'id':
        if (+this.siteId > +site.siteId) {
          value = 1;
        }
        if (+this.siteId < +site.siteId) {
          value = -1;
        }
        break;
      case 'name':
        value = this.siteName.localeCompare(site.siteName);
        break;
    }
    return value;
  }
}
export class SiteStepperModel {
  constructor(public selectedIndex: number, public siteModel?: SiteModel) {}
}
export class SolarEnergyModel {
  constructor(
    public yestEnergy?: string,
    public todayEnergy?: string,
    public energyTillDate?: string,
    public maxPowerYest?: string,
    public maxPowerToday?: string,
    public maxPowerTillDate?: string,
    public revenueYest?: string,
    public revenueToday?: string,
    public revenueTillDate?: string,
    public co2Yest?: string,
    public co2Today?: string,
    public co2TillDate?: string,
    public tariffRate?: string,
    public co2Factor?: string,
    public treessSavedTillDate?: string,
    public treessSavedYest?: string,
    public treessSavedToday?: string
  ) {
    this.revenueYest = (
      parseFloat(this.tariffRate) * parseFloat(this.yestEnergy)
    ).toString();
    this.co2Yest = (
      parseFloat(this.co2Factor) * parseFloat(this.yestEnergy)
    ).toString();
  }
}
export class Slab {
  constructor(
    public startTime?: any,
    public endTime?: any,
    public rate?: any
  ) {}
}
export class ConnectionDetailModel {
  constructor(
    public siteId?: string,
    public contractedDemand?: number,
    public connectLoad?: number,
    public peakRecordedDemand?: number,
    public threeMnthsAvgDemand?: number,
    public rrNumber?: number,
    public discomZone?: number,
    public lineType?: string,
    public demandUtilisationFactor?: number,
    public pfPenaltyLimit?: number,
    public pfIncentiveLimit?: number,
    public pfPenaltyRate?: number,
    public pfIncentiveRate?: number,
    public reqToReduceDemand?: string,
    public energyExchangeMember?: string,
    public kvaTariff?: number,
    public tou?: string,
    public co2Factor?: number,
    public rId?: string,
    public slabs?: Slab[]
  ) {}
}
export class ReportGroupModel {
  constructor(
    public siteId?: string,
    public groupRId?: any,
    public groupId?: any,
    public loadId?: any,
    public groupname?: string,
    public createNewGroup?: string
  ) {}
}

export class WaterReportGroupModel {
  constructor(
    public siteId?: string,
    public groupRId?: any,
    public groupId?: any,
    public loadId?: any,
    public groupname?: string,
    public createNewGroup?: string
  ) {}
}

export class TagParameters {
  constructor(
    public rid?: string,
    public siteID?: string,
    public loadName?: string,
    public loadRID?: string,
    public loadID?: string,
    public flowChannelName?: string,
    public time?: string,
    public paramName?: string,
    public paramValue?: string,
    public tagType?: string,
    public tagDescription?: string,
    public taggedBy?: string,
    public paramUnit?: string,
    public paramDisplayValue?: string,
    public tagValid?: string,
    public modifiedTime?: string,
    public message?: string
  ) {}
}
export class LoadParameterModel {
  constructor(
    public name?: string,
    public value?: string,
    public unit?: string,
    public selected?: boolean
  ) {}
}
export class LoadFormDataModel {
  constructor(
    public inputNo?: number,
    public outputNo?: number,
    public meter?: any,
    public inlets?: any,
    public outlets?: any
  ) {}
}
export class LoadInletModel {
  constructor(
    public name?: string,
    public flowChannelID?: string,
    public insiteFlowChannelID?: string,
    public diameter?: number,
    public massFlowRate?: number,
    public lowerThresholdTempertaure?: number,
    public upperThresholdTemperature?: number,
    public valveSwitchPresent?: boolean
  ) {}
}
export class SensorModel {
  constructor(
    public parameterType?: string,
    public parameterTypeDisplayValue?: string,
    public outputType?: string,
    public digitalOutputMapping?: any,
    public sensorPartNumber?: string
  ) {}
}
export class LoadInletSensingModel {
  constructor(
    public name?: string,
    public flowChannelID?: string,
    public ioChannnelSerialNumber?: string,
    public lowerThresholdTempertaure?: number,
    public upperThresholdTemperature?: number,
    public sensor?: SensorModel
  ) {
    this.sensor = new SensorModel();
  }
}
export class LoadMasterModel {
  constructor(
    public siteID?: string,
    public meter?: string,
    public phasetype?: string,

    public comment?: string
  ) {}
}
export class LoadModel {
  constructor(
    public order?: number,
    public loadId?: string,
    public name?: string,
    public kwRating?: number,
    public hasEnergyMeter?: boolean,
    public parameters?: any
  ) {}
}
export class Attachment {
  constructor(
    public id?: string,
    public name?: string,
    public attachmentType?: string,
    public attachmentId?: string
  ) {}
}
export class MeterModel {
  constructor(
    public order?: number,
    public make?: string,
    public type?: string,
    public serialNumber?: number,
    public meterId?: string,
    public ctAccuracy?: string,
    public ctMake?: string,
    public ctRatingPrimary?: number,
    public rId?: string,
    public meterRole?: string,
    public systemV?: string,
    public currentUnbalanceX?: number,
    public currentUnbalanceY?: number,
    public neutralILimit?: string,
    public maxPLimit?: string,
    public harmonicPowerLossLimit?: string,
    public loadRId?: string,
    public insiteMeterID?: string,
    public dcuID?: string,
    public hardwareVersion?: string,
    public toInclude?: boolean,
    public meterStatus?: string,
    public loadName?: string,
    public sampleCount?: number
  ) {}
}
export class DCUModel {
  constructor(
    public order?: number,
    public dcuMake?: string,
    public dcuName?: string,
    public dcuSerialNumber?: number,
    public firmwareVersion?: string,
    public dcuIP?: any,
    public metersConnected?: number,
    public dcuStatus?: string,
    public dcuConnectionStatus?: string,
    public dcuID?: string,
    public rId?: string,
    public siteId?: string
  ) {}
}

export class ProductModel {
  constructor(public rId?: String, public name?: String) {}
}
